module.exports = __webpack_public_path__ + "img/jinqiduiju.ea1a6f27.png";